import React, { useState } from "react";
import { createPortal } from "react-dom";
import axios from "../api/axiosInstance";

function SettlementModal({ order, onClose, onSuccess }) {
  const [status, setStatus] = useState(
    order.settlementStatus || "Unsettled"
  );

  const [comment, setComment] = useState(
    order.settlementComment || ""
  );

  const [loading, setLoading] = useState(false);

  const submit = async () => {
    try {
      setLoading(true);

      await axios.put("/Settlement", null, {
        params: {
          orderId: order.id,
          settlementStatus: status,
          settlementComment: comment,
        },
      });

      alert("وضعیت تسویه با موفقیت ثبت شد.");

      onSuccess();
    } catch (err) {
      console.error(err);

      alert(
        err?.response?.data?.message ||
          "خطا در ثبت وضعیت تسویه"
      );
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div
      className="modal-backdrop"
      onClick={onClose}
    >
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>تغییر وضعیت تسویه</h3>

          <button
            className="modal-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="modal-body">

          <div className="form-group">
            <label>شناسه سفارش</label>

            <input
              type="text"
              value={order.id}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>وضعیت تسویه</label>

            <select
              value={status}
              onChange={(e) =>
                setStatus(e.target.value)
              }
            >
              <option value="Settled">
                تسویه شده
              </option>

              <option value="Unsettled">
                تسویه نشده
              </option>

              <option value="OverDueDebt">
                بدهی معوق
              </option>

              <option value="DeleyedPayment">
                پرداخت با تاخیر
              </option>
            </select>
          </div>

          <div className="form-group">
            <label>توضیحات</label>

            <textarea
              rows={5}
              value={comment}
              onChange={(e) =>
                setComment(e.target.value)
              }
              placeholder="توضیحات..."
            />
          </div>

        </div>

        <div className="modal-buttons">

          <button
            className="btn-save"
            disabled={loading}
            onClick={submit}
          >
            {loading ? "در حال ثبت..." : "ثبت"}
          </button>

          <button
            className="btn-cancel"
            onClick={onClose}
          >
            انصراف
          </button>

        </div>

      </div>
    </div>,
    document.body
  );
}

export default SettlementModal;